@use "ui/styles/colorsOld";
@use "ui/styles/fontsOld";

.modalHeader {
  font-size: 16px;
  font-weight: 700px;
}

.warningMessageWrapper {
  padding: 1em;
}

.modalBody {
  font-size: fontsOld.$small;
  color: colorsOld.$stoneDarkX1;
}

.modalBodyText {
  font-size: 14px;
  font-weight: 400px;
  margin-bottom: 8px;
}

.confirmationInputWrapper {
  margin: 1em 0 2em 0;

  label {
    display: block;
    margin-bottom: 4px;
  }
}